import React, { Component } from "react";
//import io from 'socket.io-client';
import Hls from "hls.js";
import "./VideoStreamTV.css";
import FakeData from "../fake-data";
import {
  EmptyState,
  LoadingState,
  ShareContent,
  InputField,
  ShimmerView,
  WhoToSeePicker
} from "./Common";
import {ScrollView} from 'react-native';
import static_img from './film-grain.gif';
const LIMIT_CUT_OFF = 120000;
const WARN_CUT_OFF = LIMIT_CUT_OFF - 10000;
const {flvjs,FLVJSPlayback, Clappr} = FakeData;

export default class VideoStreamTV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStreaming: this.props.isLive ? this.props.isLive : false,
      isHiding: this.props.isLive ? this.props.isLive : false,
      current: 0,
      msg : !props.isPlayOnly?"Please select a video to watch!":"Please wait... loading video",
      vid_id: props.vid_id ? props.vid_id : false,
      searchQuery: "",
      isTyping: false,
      isShowingComments: true,
      isPlaying: props.video?true:false,
      video_session_id: Date.now(),
      comments: props.video?props.video.comments:[],
      chunks: [],
      offlineVideos: props.videos?props.videos:[],
      videos: [],
      isFiltering: false,
      video: props.video?props.video:null,
      isMute: false,
      blob: new Blob([], {
        type: "video/webm"
      }),
      comment_msg:"",
      isBuffering: false,
      currentTime: 0,
      isSharing: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const _that = this;
    this.videos = [];
    this._videos = [];
    this.isPlaying = false;
    this.current = 0;
    if(!this.props.isPlayOnly && !this.props.videos){
      this.getVideos();
      this.getOfflineVideos();
    }
    
    this.watcher = null;
    this.viewer = null;
    this.videoElem = null;
    if (window.SPToggleBody) {
      window.SPToggleBody();
    }

    if(this.props.isPlayOnly){
      this.getWatcherWS(this.props.videoId);
      this.getVideData(this.props.videoId, (vid)=>{
        //console.log(vid)
        _that.setView(vid.name);
        if (vid.is_live) {
          _that.getViewerWS(vid.name);
        }
      })
    }

    if(this.props.video){
      this.getOfflineVideos();
      this.getWatcherWS(this.props.video.name);
      this.getVideData(this.props.video.name, (vid)=>{
        _that.setView(_that.props.video.name);
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (window.SPToggleBody) {
      window.SPToggleBody();
    }
  }

  getVideos = () => {
    const _that = this;
    FakeData.post(
      "http://supotsu.com:2018",
      {},
      {
        success(res) {
          if (!_that._isMounted) {
            return;
          }
          _that.setState({ videos: res });
          FakeData.listify(res).forEach((item, i) => {
            if (
              _that.state.video !== null &&
              item.name === _that.state.video.name
            ) {
              _that.setState({
                video: item
              });
            }
          });

          setTimeout(() => {
            _that.getVideos();
          }, 1000);
        },
        error(res) {
          _that.setState({ videos: [] });
        }
      }
    );
  };

  getOfflineVideos = () => {
    const _that = this;
    const data = {
      id: FakeData.getData("yoo").id
    };

    FakeData.post(FakeData.apiURL+"/got-offline-videos", data, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }

        let withNewVideo = false;

        const _offlines = res.filter((item, i) => {
          if (_that.state.vid_id) {
            withNewVideo = true;
            return item._id === _that.state.vid_id;
          } else if (!_that.state.video) {
            return false;
          }
          return (
            item._id === _that.state.video._id && !_that.state.video.is_live
          );
        });

        //console.log(_offlines)

        if (_offlines[0]) {
          if (withNewVideo) {
            _that.setState({
              video: _offlines[0],
              comments: _offlines[0].comments,
              offlineVideos: _that.props.videos?_that.props.videos:res,
              vid_id: false,
              isPlaying: true
            });
          } else {
            _that.setState({
              comments: _offlines[0].comments,
              offlineVideos: _that.props.videos?_that.props.videos:res
            });
          }
        } else {
          _that.setState({
            offlineVideos: _that.props.videos?_that.props.videos:res
          });
        }

        setTimeout(() => {
          _that.getOfflineVideos();
        }, 1000);
      }
    });
  };

  onVideoSelect = video => {
    this.videos = [];
    this.isPlaying = false;
    this.current = 0;
    if (this.watcher !== null) {
      this.watcher.close();
      this.watcher = null;
    }

    this.hasPlayed = false;

    if (this.viewer !== null) {
      this.viewer.close();
      this.viewer = null;
    }
    this.setState({
      video,
      comments: video.msgs ? video.msgs : video.comments,
      isPlaying: true,
      currentTime: 0,
      current: 0,
      vid_id: false
    });
    this.getWatcherWS(video.name);
    this.setView(video.name);

    clearTimeout(this.getVidInterval);

    if (video.is_live) {
      this.getViewerWS(video.name);
    }
  };

  getWatcherWS = string => {
    this.watcher = new WebSocket("ws://supotsu.com:2018/view/" + string);
    const { comments } = this.state;
    const _that = this;
    this.watcher.onmessage = msg => {
      _that.state.comments.push(JSON.parse(msg.data));
      _that.setState({ comments: _that.state.comments });
    };
  };

  getViewerWS = string => {
    this.viewer = new WebSocket("ws://supotsu.com:2018/viewer/" + string);
    const _that = this;
    this.setState({ isBuffering: true });
    this.viewer.onmessage = msg => {};
  };

  playerVideo = () => {
    const _that = this;
    const { current, video } = this.state;
    if (!this.videos[current]) {
      if (!video.is_live) {
        _that.isPlaying = false;
        _that.setState({
          isPlaying: false
        });
      } else {
        _that.setState({
          isBuffering: true
        });

        _that.playerVideo();
      }
      return;
    } else {
      const vid = !video ? this.videos[current] : video;
      let videoElem = FakeData.$("video");
      const videoHolder = FakeData.$(".live-video-holder");

      FakeData.$(vid).on("ended", e => {
        if (_that.videos.length === current) {
          _that.isPlaying = false;
          console.log("reached");
          return;
        } else {
          _that.setState({
            current: current + 1
          });
          console.log('"rezched play"');
          const _vid = _that.videos[current];
          if (!_vid) {
            _that.setState({
              isBuffering: true
            });
            _that.isPlaying = false;
          }
          console.log(_vid);
          console.log(_that.videos);
          _that.playerVideo();
        }
      });

      setTimeout(() => {
        _that.setState({
          isBuffering: false
        });

        videoHolder.html(vid);
        vid.play();
        console.log("playing");
      }, 1500);
    }
  };

  getVideoElem = (string, _video) => {
    const _that = this;
    let videoElem = document.createElement("video");
    videoElem.className = "remote";
    //_that.videoElem.load();
    const video = _video || _that.state.video;

    videoElem.preload = "auto";
    videoElem.autoplay = true;
    //videoElem.setAttribute("src", "http://supotsu.com:2018/watch/" + string)
    window
      .fetch("http://supotsu.com:2018/watch/" + string)
      .then(res => {
        res.blob();
      })
      .then(b => {
        videoElem.src = "http://supotsu.com:2018/watch/" + string;
        videoElem.play();
        videoElem.currentTime = video.current_time;
      })
      .catch(e => {
        _that.setState({ isBuffering: false });
      });

    _that.setState({ isBuffering: false });
    _that.getVideData(string);
    //console.log(video.current_time)
    videoElem.addEventListener("ended", function(e) {
      _that.setState({ isBuffering: true, currentTime: currentTime });
      let currentTime = videoElem.currentTime;
      if (_that.state.video.ended) {
        _that.setState({ isPlaying: false, isBuffering: false });
        document
          .querySelector(".video-stream-tv-video-body")
          .removeChild(videoElem);
        return;
      } else {
        document
          .querySelector(".video-stream-tv-video-body")
          .removeChild(videoElem);
        _that.getVideoElem(string);
      }
    });

    videoElem.addEventListener("progress", function(e) {
      _that.setState({ currentTime: e.currentTarget.currentTime });
    });

    document
      .querySelector(".video-stream-tv-video-body")
      .appendChild(videoElem);
    _that.videoElem = videoElem;
  };

  loadBlob = string => {
    const _that = this;
    const _videoElem = FakeData.$("video.remote").get(0);
    //_that.videoElem.load();
    _that.setState({ isBuffering: true });
    window
      .fetch(
        "http://supotsu.com/cgi-enabled/video.php?file=" +
          string +
          "/" +
          string +
          ".webm"
      )
      .then(res => res.blob())
      .then(b => {
        const videoElem = FakeData.$("video.remote").get(0);
        videoElem.setAttribute("src", window.URL.createObjectURL(b));
        //videoElem.preload = "auto";
        videoElem.play();
        _that.setState({ isBuffering: false });
      })
      .catch(e => {
        console.log(e);
        _that.setState({ isPlaying: false, isBuffering: false });
      });
  };

  getVideoDuration = path => {
    const _vid = document.createElement("video");
    _vid.src = path;
    return {
      duration: _vid.duration,
      buffered: _vid.buffered
    };
  };

  getVideData = (id, cb = false) => {
    const _that = this;
    FakeData.post(
      "http://supotsu.com:2018/get/" + id,
      {},
      {
        success(res) {
          if (!_that._isMounted && _that.watcher === null) {
            return;
          }

          if (!res.error) {
            _that.setState({ video: res });
            if(_that.props.isPlayOnly){
              _that.setState({ isPlaying:true });
            }
            if (cb) {
              cb(res);
            }
          } else{
            _that.setState({ msg: res.msg });
          }

          if (!cb) {
            _that.getVidInterval = setTimeout(() => {
              _that.getVideData(id);
            }, 1000);
          }
        },
        error(res) {}
      }
    );
  };

  setView = vid_id => {
    const data = {
      user: {
        id: FakeData.getData("yoo").id,
        name: FakeData.getData("yoo").name,
        username: FakeData.getData("yoo").username,
        image: FakeData.getData("yoo").image,
        type: "F"
      }
    };

    const apiData = {
      user: {
        id: FakeData.getData("yoo").id,
        name: FakeData.getData("yoo").name,
        user: FakeData.getData("yoo").username,
        image: FakeData.getData("yoo").image,
        type: "F"
      }
    };

    const _that = this;

    FakeData.post("http://supotsu.com:2018/update_views/" + vid_id, data, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }

        if (res.msg === "User was set") {
          _that.state.video.users.push(data.user);
          _that.state.video.views++;
          _that.setState({ video: _that.state.video });
        }
      },
      error(res) {}
    });
  };

  onKeyPress = e => {
    const _that = this;
    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      const _data = {
        user: {
          id: FakeData.getData("yoo").id,
          name: FakeData.getData("yoo").name,
          username: FakeData.getData("yoo").username,
          image: FakeData.getData("yoo").image
        },
        msg: this.state.comment_msg,
        timestamp: Date.now()
      };
      if (
        this.watcher !== null &&
        this.state.comment_msg.length > 0 &&
        (this.state.video && this.state.video.is_live)
      ) {
        this.watcher.send(FakeData.stringify(_data));
        this.setState({ comment_msg: "" });
      }

      if (this.state.video) {
        const commentData = {
          comment: _data,
          id: _that.state.video._id
        };
        FakeData.post(
          FakeData.apiURL+"/go-live-comment-add",
          commentData,
          {
            success(res) {
              FakeData.alert("Comment added....");
              _that.setState({ comment_msg: "" });
            },
            error(err) {
              FakeData.alert("Comment not added....");
            }
          }
        );
      }
    }
  };

  onNextVideo = () => {
    let videos = this._videos;
    let index = false;
    videos.sort((a, b) => {
      var date_B = new Date(b.date ? b.date : "today").getTime();
      var is_live = Boolean(a.is_live || b.is_live);
      var date_A = new Date(a.date).getTime();
      return date_B - date_A || is_live;
    });

    videos.forEach((item, i) => {
      if (item._id === this.state.video._id) {
        if (videos[i + 1]) {
          index = true;
          this.onVideoSelect(videos[i + 1]);
          this.setState({ isPlaying: true });
        }
      }
    });

    if (!index) {
      this.setState({ isPlaying: false });
    }
  };

  _getVideos = () => {
    const videos = {};
    const _restVideos = [];
    this.state.offlineVideos.forEach((offlineVideo, i) => {
      if (!videos[offlineVideo.name]) {
        const _vid = {
          live: false,
          offline: offlineVideo
        };

        videos[offlineVideo.name] = _vid;
      } else {
        let _vid = videos[offlineVideo.name];
        videos[offlineVideo.name] = {
          live: videos[offlineVideo.name].live,
          offline: offlineVideo
        };
      }
    });

    this.state.videos.forEach((video, i) => {
      if (!videos[video.name]) {
        const _vid = {
          live: video,
          offline: false
        };

        videos[video.name] = _vid;
      } else {
        let _vid = videos[video.name];
        if (
          videos[video.video] && videos[video.video].offline &&
          videos[video.video].offline.block.indexOf(
            FakeData.getData("yoo").id
          ) > -1
        ) {
          delete videos[video.name];
        } else {
          videos[video.name] = {
            offline: videos[video.name].offline,
            live: video
          };
        }
      }
    });

    Object.keys(videos).forEach((key, i) => {
      if (!videos[key].live) {
        _restVideos.push(videos[key].offline);
      } else {
        _restVideos.push(videos[key].live);
      }
    });

    return _restVideos;
  };

  render() {
    const {
      blob,
      isSharing,
      isFiltering,
      isMute,
      isShowingComments,
      isBuffering,
      isHiding,
      isStreaming,
      searchQuery,
      comments,
      comment_msg,
      isTyping,
      video,
      isPlaying
    } = this.state;
    const { style, isPreview, onClose, user, isPlayOnly } = this.props;
    comments.sort((a, b) => {
      return a.timestamp - b.timestamp;
    });

    let videos = this._getVideos(); //this.state.videos.concat(this.state.offlineVideos);

    videos.sort((a, b) => {
      var date_B = new Date(b.date ? b.date : "today").getTime();
      var is_live = Boolean(a.is_live || b.is_live);
      var date_A = new Date(a.date).getTime();
      return date_B - date_A || is_live;
    });

    this._videos = videos;
    if (isPlayOnly) {
      return (
        <div
          className="video-stream-tv"
          key={video !== null ? video.name : "init-view"}
          style={{ width: "100%", height: "100%", ...style }}
        >
          {(isHiding || isPlayOnly) && (
            <div
              className={
                isHiding
                  ? "video-stream-tv-left-head is-expanded"
                  : "video-stream-tv-left-head"
              }
              style={{
                background: "transparent",
                width: isShowingComments?"60%":"80%"
              }}
            >
              <img src={"images/supotsu_logo.svg"} />
              <div className={"score-holder"}>
                {this.props.scoreBoard}
              </div>
            </div>
          )}

          <div
            className="video-stream-tv-right"
            style={{
              width: isHiding ? "100%" : ""
            }}
          >
            <div
                className={"video-stream-tv-video is-game"}
                style={{
                  width: this.state.isFiltering?"calc(100% - 305px)":this.state.isShowingComments?"calc(100% - 30vw)":""
                }}
              >
                <div
                  className={"video-stream-tv-video-head is-game"}
                  style={{
                    marginRight: "100px"
                  }}
                >
                  <img src={FakeData.getData("yoo").image} />
                  {onClose && (
                    <button className={"close-me"} onClick={onClose}>
                      CLOSE
                    </button>
                  )}
                </div>
                {!isPlaying && (
                  <VideoBlankView msg={this.state.msg} video={video} play={()=>{
                    this.setState({ isPlaying: true });
                  }}/>
                )}
                {isPlaying &&
                  video !== null && (
                    <div
                      className={
                        isHiding
                          ? "video-stream-tv-video-body is-expanded"
                          : "video-stream-tv-video-body"
                      }
                    >
                      <VideoPlayer
                        useClapper={true}
                        video={video}
                        channel={video.name}
                        onEnd={bool => {
                          this.setState({ isPlaying: bool });
                        }}
                        onEnded={() => {
                          if (video.is_live) {
                            return;
                          } else {
                            this.onNextVideo();
                          }
                        }}
                        onBufferChange={bool => {
                          this.setState({ isBuffering: bool });
                        }}
                      />
                      {this.isBuffering && (
                        <div className="video-stream-tv-video-body-buffering">
                          <LoadingState
                            isShown={isBuffering}
                            text={""}
                            spinnerStyle={{ width: "50px", height: "50px" }}
                            style={{
                              height: "100%",
                              color: "#fff",
                              background: "transparent"
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}

                <div
                  className={
                    isHiding
                      ? "video-stream-tv-video-chat"
                      : "video-stream-tv-video-chat is-expanded"
                  }
                />
                <div className={"video-stream-tv-video-foot"} style={{
                  padding: "10px 20px"
                }}>
                  {this.props.gameBannerSlider}
                </div>
              </div>
              <div className={"video-stream-tv-timeline is-game"} style={{
                marginRight: this.state.isShowingComments?"0":"-30vw",
                width: isFiltering?"305px":""
              }}>
                  {!isFiltering &&
                    <div className={"video-stream-tv-timeline-btn"} onClick={()=>{
                      this.setState({ isShowingComments: !isShowingComments });
                    }}>
                      {!isShowingComments &&
                        <div
                          className={"toggle-search-tv"}
                          onClick={() => {
                            if (isStreaming) {
                              return;
                            }

                            this.setState({ isHiding: false });
                          }}
                        >
                          <span />
                          <span />
                          <span />
                        </div>
                      }
                      {isShowingComments &&
                        <div
                          className={"toggle-search-tv active"}
                          onClick={() => {
                            if (isStreaming) {
                              return;
                            }

                            this.setState({ isHiding: true });
                          }}
                        >
                          <span />
                          <span />
                        </div>
                      }
                    </div>
                  }
                  <div className={"video-stream-tv-timeline-btn btn-filter"} style={{
                    marginTop: isFiltering?"0px":""
                  }} onClick={()=>{
                    this.setState({ isFiltering: !isFiltering, isShowingComments: (!isShowingComments)?true:isShowingComments });
                  }}>
                    <i className={"material-icons"} style={{
                      color: "#fff"
                    }}>{isFiltering?"done":"sort"}</i>
                  </div>
                  <div className={"video-stream-tv-timeline-filter"} style={{
                      display:isFiltering?"":"none"
                    }}>
                      {this.props.filter}
                    </div>
                  {this.props.timeLine}
              </div>
          </div>
          {isSharing &&
            video !== null && (
              <ShareContent
                hideSportLabel={true}
                style={null}
                isVideo={true}
                post={video}
                type={"VIDEO"}
                user={FakeData.getData("yoo")}
                userType={"F"}
                isOpen={isSharing}
                onClose={() => {
                  this.setState({ isSharing: false });
                }}
              >
                <VideoItem
                  onVideoSelect={() => {}}
                  isLive={video.is_live}
                  video={video}
                />
              </ShareContent>
            )}
        </div>
      );
    }
    return (
      <div
        className="video-stream-tv"
        key={video !== null ? video.name : "init-view"}
        style={{ width: "100%", height: "100%", ...style }}
      >
        {!isHiding && (
          <div
            className="video-stream-tv-left"
            style={{
              left: isHiding ? "-450px" : "0px",
              width: isHiding ? "0px" : ""
            }}
          >
            <div
              className="video-stream-tv-left-head"
              style={{
                left: isHiding ? "-450px" : "0px"
              }}
            >
              <img src={"images/supotsu_logo.svg"} />
              {
                <div
                  className={"toggle-search-tv active"}
                  onClick={() => {
                    if (isStreaming) {
                      return;
                    }

                    this.setState({ isHiding: true });
                  }}
                >
                  <span />
                  <span />
                </div>
              }
            </div>
            <div className="video-stream-tv-left-filter-icons">
              {FakeData.getDummy(7).map((item, i) => {
                return (
                  <div key={i} className="video-stream-tv-left-filter-icon" />
                );
              })}
            </div>
            <div className="video-stream-tv-left-filter">
              <input
                value={searchQuery}
                placeholder={"Search"}
                onChange={e => {
                  this.setState({ searchQuery: e.target.value });
                }}
              />
              <i className={"material-icons"}>search</i>
            </div>
            <div className="video-stream-tv-left-body">
              {videos
                .filter((item, i) => {
                  var index = FakeData.nullify(item.desc)
                    .toLowerCase()
                    .indexOf(searchQuery.toLowerCase());
                  return index > -1;
                })
                .map((item, i) => {
                  return (
                    <VideoItem
                      onVideoSelect={this.onVideoSelect.bind(this)}
                      key={i}
                      isLive={item.is_live}
                      video={item}
                    />
                  );
                })}
              <EmptyState
                isShown={videos.length === 0 ? true : false}
                icon={"theaters"}
                text={"No live videos at the moment!"}
              />
            </div>
          </div>
        )}

        {isHiding && (
          <div
            className={
              isHiding
                ? "video-stream-tv-left-head is-expanded"
                : "video-stream-tv-left-head"
            }
            style={{
              background: "transparent"
            }}
          >
            <img src={"images/supotsu_logo.svg"} />
            {!isStreaming && (
              <div
                className={"toggle-search-tv"}
                onClick={() => {
                  if (isStreaming) {
                    return;
                  }

                  this.setState({ isHiding: false });
                }}
              >
                <span />
                <span />
                <span />
              </div>
            )}
          </div>
        )}

        <div
          className="video-stream-tv-right"
          style={{
            width: isHiding ? "100%" : ""
          }}
        >
          {!isStreaming && (
            <div
              className={
                isHiding
                  ? "video-stream-tv-video is-expanded"
                  : "video-stream-tv-video"
              }
            >
              <div
                className={
                  isHiding
                    ? "video-stream-tv-video-head is-expanded"
                    : "video-stream-tv-video-head"
                }
              >
                {!isStreaming && (
                  <button
                    className={"live-tv"}
                    onClick={() => {
                      this.setState({ isHiding: true, isStreaming: true });
                    }}
                  >
                    GO LIVE
                  </button>
                )}
                {isStreaming && (
                  <button
                    className={"live-tv"}
                    onClick={() => {
                      this.setState({ isHiding: false, isStreaming: false });
                    }}
                  >
                    Cancel
                  </button>
                )}
                <img src={FakeData.getData("yoo").image} />
                {onClose && (
                  <button className={"close-me"} onClick={onClose}>
                    CLOSE
                  </button>
                )}
              </div>
              {!isPlaying && (
                <VideoBlankView msg={this.state.msg} video={video} play={()=>{
                  this.setState({ isPlaying:true });
                }}/>
              )}
              {isPlaying &&
                video !== null && (
                  <div
                    className={
                      isHiding
                        ? "video-stream-tv-video-body is-expanded"
                        : "video-stream-tv-video-body"
                    }
                  >
                    <VideoPlayer
                      useClapper={true}
                      video={video}
                      channel={video.name}
                      onEnd={bool => {
                        this.setState({ isPlaying: bool });
                      }}
                      onEnded={() => {
                        if (video.is_live) {
                          return;
                        } else {
                          this.onNextVideo();
                        }
                      }}
                      onBufferChange={bool => {
                        this.setState({ isBuffering: bool });
                      }}
                    />
                    {this.isBuffering && (
                      <div className="video-stream-tv-video-body-buffering">
                        <LoadingState
                          isShown={isBuffering}
                          text={""}
                          spinnerStyle={{ width: "50px", height: "50px" }}
                          style={{
                            height: "100%",
                            color: "#fff",
                            background: "transparent"
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}

              <div
                className={
                  isHiding
                    ? "video-stream-tv-video-chat"
                    : "video-stream-tv-video-chat is-expanded"
                }
              />
              {isPlaying &&
                video !== null && (
                  <div className={"video-stream-tv-video-foot"}>
                    <div className={"video-stream-tv-video-foot-desc"}>
                      <div className={"video-stream-tv-video-foot-desc-lbl"}>
                        {video.is_live && <span className={"lbl"}>LIVE</span>}
                        {!video.is_live &&
                          video.is_recorded && (
                            <span className={"lbl"}>Recorded Live</span>
                          )}
                        <i className="material-icons">person</i>
                        {video.is_live && (
                          <span className={"v-count"}>
                            {
                              FakeData.shortDigit(
                                video === null ? 0 : video.watchers
                              ).text
                            }
                          </span>
                        )}
                        {!video.is_live &&
                          !video.is_recorded && (
                            <span className={"v-count"}>
                              {
                                FakeData.shortDigit(
                                  video === null ? 0 : video.views
                                ).text
                              }
                            </span>
                          )}
                      </div>
                      <div className={"video-stream-tv-video-foot-desc-ctx"}>
                        {video.desc}
                      </div>
                      {this.is && (
                        <i className="material-icons">favorite_border</i>
                      )}
                      <div
                        className={"video-stream-tv-video-foot-desc-user-lbl"}
                      >
                        {video.sport && (
                          <div
                            className={
                              "video-stream-tv-video-foot-desc-user-lbl-sport"
                            }
                          >
                            {video.sport}
                          </div>
                        )}
                        {video.location && <span>{video.location}</span>}
                        {video.feature_user.id !== null && (
                          <div
                            className={
                              "video-stream-tv-video-foot-desc-user-lbl-ft-l"
                            }
                          >
                            <div
                              className={
                                "video-stream-tv-video-foot-desc-user-lbl-ft-lu"
                              }
                            >
                              <img src={video.feature_user.image} />
                              <span>{video.feature_user.name}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={"video-stream-tv-video-foot-actions"}>
                      <div className={"video-stream-tv-video-foot-user"}>
                        <img src={video.user.image} />
                        <span>{video.user.name}</span>
                      </div>
                      {this.is && (
                        <i
                          className="material-icons"
                          onClick={() => {
                            this.setState({ isMute: !isMute });
                          }}
                        >
                          {isMute ? "volume_up" : "volume_off"}
                        </i>
                      )}
                      <div style={{ flex: 1 }} />
                      <div
                        className={"video-stream-tv-video-foot-side-actions"}
                      >
                        <span
                          onClick={() => {
                            this.setState({ isSharing: true });
                          }}
                        >
                          Share
                        </span>
                        {this.is && (
                          <i
                            className="material-icons"
                            onClick={() => {
                              document
                                .querySelector("video")
                                .requestFullscreen();
                            }}
                          >
                            aspect_ratio
                          </i>
                        )}
                        {this.is && (
                          <i className="material-icons">question_answer</i>
                        )}
                      </div>
                    </div>
                  </div>
                )}
            </div>
          )}
          {isStreaming && (
            <GoLiveView
              key={this.state.video_session_id}
              hasCancel={this.props.isLive ? false : true}
              user={this.props.user ? this.props.user : false}
              canClose={onClose ? true : false}
              isHiding={true}
              isStreaming={isStreaming}
              onCloseStream={() => {
                this.setState({ isStreaming: false, isHiding: false });
              }}
              isGame={this.props.isGame ? true : false}
              onClose={() => {
                if (!this.props.isGame) {
                  this.setState({ isStreaming: false, isHiding: false });
                }

                if (this.props.onClose) {
                  this.props.onClose();
                }
              }}
              setComments={comments => {
                //this.setState({comments:comments});
              }}
              setWatcher={id => {
                this.getWatcherWS(id);
              }}
              onReset={() => {
                this.setState({ video_session_id: Date.now() });
              }}
            />
          )}
          {video !== null && this.renderVideoComments(video)}
          {video === null && (
            <div
              className={
                isHiding
                  ? "video-stream-tv-chat is-expanded"
                  : "video-stream-tv-chat"
              }
            >
              <div className="video-stream-tv-chat-list">
                <EmptyState
                  isShown={comments.length === 0 ? true : false}
                  icon={"theaters"}
                  text={"Nothing to show"}
                />
              </div>
            </div>
          )}
        </div>
        {isSharing &&
          video !== null && (
            <ShareContent
              hideSportLabel={true}
              style={null}
              isVideo={true}
              post={video}
              type={"VIDEO"}
              user={FakeData.getData("yoo")}
              userType={"F"}
              isOpen={isSharing}
              onClose={() => {
                this.setState({ isSharing: false });
              }}
            >
              <VideoItem
                onVideoSelect={() => {}}
                isLive={video.is_live}
                video={video}
              />
            </ShareContent>
          )}
      </div>
    );
  }

  renderVideoComments = (_video) => {
    const {
      blob,
      isSharing,
      isFiltering,
      isMute,
      isShowingComments,
      isBuffering,
      isHiding,
      isStreaming,
      searchQuery,
      comments,
      comment_msg,
      isTyping,
      video,
      isPlaying
    } = this.state;
    const { style, isPreview, onClose, user, isPlayOnly } = this.props;
    comments.sort((a, b) => {
      return a.timestamp - b.timestamp;
    });

    let videos = this._getVideos(); //this.state.videos.concat(this.state.offlineVideos);

    videos.sort((a, b) => {
      var date_B = new Date(b.date ? b.date : "today").getTime();
      var is_live = Boolean(a.is_live || b.is_live);
      var date_A = new Date(a.date).getTime();
      return date_B - date_A || is_live;
    });

    this._videos = videos;
    if(!video.isLive && !video.has_chat){
      return null
    }
    return(
      <div
        className={
          isHiding
            ? "video-stream-tv-chat is-expanded"
            : "video-stream-tv-chat"
        }
      >
        <ScrollView className="video-stream-tv-chat-list">
          {comments.map((item, i) => {
            return (
              <div className="video-stream-tv-chat-list-item" key={i}>
                <img src={item.user.image} />
                <span>{item.msg}</span>
              </div>
            );
          })}
          <EmptyState
            isShown={comments.length === 0 ? true : false}
            icon={"chat_bubble"}
            text={"Send a text to viewers"}
          />
        </ScrollView>
        <div className="video-stream-tv-chat-input">
          {!isTyping && (
            <span
              onClick={() => {
                this.setState({ isTyping: true });
              }}
            >
              Say something
            </span>
          )}
          {isTyping && <img src={FakeData.getData("yoo").image} />}
          {isTyping && (
            <input
              value={this.state.comment_msg}
              ref={ref => {
                if (ref) {
                  ref.focus();
                }
              }}
              onBlur={() => {
                this.setState({ isTyping: false });
              }}
              onChange={e => {
                this.setState({ comment_msg: e.target.value });
              }}
              onKeyDown={this.onKeyPress.bind(this)}
            />
          )}
        </div>
      </div>
    )
  }
}

export const VideoBlankView = ({msg, video, play}) => {
  return(
    <div className={"video-stream-tv-video-holder"} style={{
      height: "calc(100% - 200px)",
      background: "url(http://supotsu.com/images/film-grain.gif)"
    }}>
                    {video !== null && (
                      <span
                        className={"video-stream-tv-video-holder-btn"}
                        onClick={play}
                      >
                        <i className={"material-icons"}>play_arrow</i>
                      </span>
                    )}
                    {video === null && (
                      <span
                        className={"video-stream-tv-video-holder-btn"}
                        onClick={() => {}}
                      >
                        <i className={"material-icons"}>theaters</i>
                      </span>
                    )}
                    {video !== null &&
                      !video.is_live && (
                        <span className={"video-stream-tv-video-holder-time"}>
                          {FakeData.moment(video.date).fromNow()}
                        </span>
                      )}
                    {video !== null &&
                      video.desc !== "" && (
                        <span className={"video-stream-tv-video-holder-desc"}>
                          {video.desc}
                        </span>
                      )}
                    {video === null && (
                      <span className={"video-stream-tv-video-holder-desc"}>
                        {msg}
                      </span>
                    )}
                    {video !== null && (
                      <div className={"video-stream-tv-video-holder-user"}>
                        <img src={FakeData.getData("yoo").image} />
                        <span>{FakeData.getData("yoo").name}</span>
                      </div>
                    )}
                  </div>
  )
}

export class VideoPlayer extends Component {
  constructor(p) {
    super(p);
    this.state = {
      video: this.props.video
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this._isMounted = true;
    const _that = this;
    this.player = null;
    const onEnd = () => {
      if (_that.props.onEnded) {
        _that.props.onEnded();
      }
    };
    const { video, useClapper } = this.props;
    const opts = {
      width: "100%",
      height: "100%",
      autoPlay: true,
      watermark: FakeData.baseURL + "/images/supotsu_logo.svg",
      position: "top-left",
      watermarkLink: FakeData.baseURL,
      events: {
        onPlay: () => {
          console.log("playing...");
        },
        onEnded: () => {
          console.log("Ended....");
          onEnd();
        }
      }
    };

    //const _that = this;
    if (this.state.video.is_live) {
      if (this.props.useClapper) {
        this.player = new Clappr.Player({
          source: video.hls,
          poster: video.poster,
          ...opts
        });

        this.player.attachTo(this.refs["clappr-holder"]);
        if (this.props.onBufferChange) {
          this.props.onBufferChange(false);
        }
      } else {
        this.startVideo(true);
      }
    } else {
      if (this.props.useClapper) {
        this.player = new Clappr.Player({
          source:
            "http://supotsu.com:2017/video/" + this.props.channel + ".flv",
          poster: video.poster,
          mimeType: "video/flv",
          plugins: [window.FLVJSPlayback],
          playback: {
            flvjsConfig: {}
          },
          ...opts
        });

        this.player.attachTo(this.refs["clappr-holder"]);
        if (this.props.onBufferChange) {
          this.props.onBufferChange(false);
        }
      } else {
        this.startFLV();
      }
    }

    if (this.state.video._id) {
      this.watch();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  watch = () => {
    const _that = this;
    const data = {
      user: {
        id: FakeData.getData("yoo").id,
        name: FakeData.getData("yoo").name,
        image: FakeData.getData("yoo").image,
        type: "F",
        user: FakeData.getData("yoo").username
      },
      id: this.state.video._id
    };

    FakeData.post(FakeData.apiURL+"/go-live-watch", data, {
      success(res) {
        if (res.error && _that._isMounted) {
          setTimeout(() => {
            _that.watch;
          }, 3000);
        }
      },
      error(err) {
        if (_that._isMounted) {
          setTimeout(() => {
            _that.watch;
          }, 3000);
        }
      }
    });
  };

  startVideo = (isLive = false) => {
    if (Hls.isSupported() && this.refs.video) {
      const channel = this.props.channel;
      const _this = this;
      const streamURL = `http://supotsu.com:2017/live/${channel}/index.m3u8`;

      const video = this.refs.video;
      video.addEventListener("contextmenu", e => {
        e.preventDefault();
        return false;
      });

      const hls = new Hls();
      hls.loadSource(streamURL);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play();
        if (_this.props.onBufferChange) {
          _this.props.onBufferChange(false);
        }
      });

      hls.on(Hls.Events.MEDIA_DETACHING, () => {
        console.log("removing data");
      });
    } else if (this.refs.video.canPlayType("application/vnd.apple.mpegurl")) {
      const channel = this.props.channel;
      const _this = this;
      const streamURL = `http://supotsu.com:2017/live/${channel}/index.m3u8`;

      const video = this.refs.video;
      video.src = streamURL;
      video.addEventListener("canplay", () => {
        video.play();
        if (_this.props.onBufferChange) {
          _this.props.onBufferChange(false);
        }
      });
    }
  };

  startFLV = () => {
    if (flvjs.isSupported() && this.refs.video) {
      var videoElement = this.refs.video;
      var flvPlayer = flvjs.createPlayer({
        type: "flv",
        url: "http://supotsu.com:2017/video/" + this.props.channel + ".flv"
      });
      flvPlayer.attachMediaElement(videoElement);
      flvPlayer.load();
      flvPlayer.play();
      if (this.props.onBufferChange) {
        this.props.onBufferChange(false);
      }
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { video, useClapper } = this.props;
    const {} = this.state;
    if (useClapper) {
      return <div className={"live-video-holder"} ref={"clappr-holder"} />;
    }
    return (
      <div className={"live-video-holder"}>
        <video ref={"video"} autoPlay={true} controls={false} />
      </div>
    );
  }
}

class VideoItem extends Component {
  constructor(p) {
    super(p);
    this.state = {
      frameOffset: 4,
      frame: null,
      hasImage: true
    };
  }

  componentDidMount() {
    this._isMounted = true;
    //this.getFrame()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getVideoDuration = dur => {
    return {
      duration: dur,
      format: this.getTimeFormat(parseInt(dur) * 1000)
    };
  };

  getTimeFormat = (ms = 1000) => {
    var duration = FakeData.moment.duration(ms);
    if (duration.asHours() > 1) {
      return (
        Math.floor(duration.asHours()) +
        FakeData.moment.utc(duration.asMilliseconds()).format(":mm:ss")
      );
    } else {
      return FakeData.moment.utc(duration.asMilliseconds()).format("mm:ss");
    }
  };

  getFrame = () => {
    if (this._isMounted) {
      const { frameOffset } = this.state;
      const { video, isLive } = this.props;
      const _vid = document.createElement("video");
      _vid.preload = "auto";
      _vid.src =
        "http://supotsu.com/cgi-enabled/video.php?file=" +
        video.name +
        "/" +
        video.name +
        ".webm";
      const _that = this;
      const _canvas = document.createElement("canvas");
      _vid.addEventListener("loadeddata", e => {
        _vid.currentTime = frameOffset;
        _canvas.width = 100;
        _canvas.height = 60;
        const _frame = _canvas.toDataURL();

        const ctx = _canvas.getContext("2d");
        ctx.drawImage(_vid, 0, 0, 100, 60);
        var nextFrame = frameOffset + 4 >= _vid.duration ? 4 : frameOffset + 4;
        _that.setState({ frame: _frame, frameOffset: nextFrame });
      });
    }
  };

  render = () => {
    const { frame } = this.state;
    const { video, isLive } = this.props;

    return (
      <div
        className={"video-stream-tv-item"}
        onClick={() => {
          if (this.props.onVideoSelect) {
            this.props.onVideoSelect(video);
          }
        }}
      >
        {this.state.hasImage &&
          <img src={video.poster} onError={()=>{
            this.setState({ hasImage: false });
          }} />
        }
        {!this.state.hasImage && video.user && video.user.image &&
          <img src={video.user.image} onError={()=>{
            this.setState({ hasImage: false });
          }} />
        }
        <div className={"video-stream-tv-item-info"}>
          <div className={"video-stream-tv-item-info-time"}>
            {isLive && (
              <span
                style={{
                  background: "#e03"
                }}
              >
                LIVE
              </span>
            )}
            {!isLive &&
              !video.is_recorded &&
              video.current_time && (
                <span
                  style={{
                    background: "#345"
                  }}
                >
                  {this.getVideoDuration(video.current_time).format}
                </span>
              )}
            {!isLive &&
              video.is_recorded && (
                <span
                  style={{
                    background: "#e03"
                  }}
                >
                  {"Recorded Live"}
                </span>
              )}
            <span>{FakeData.moment(video.date).fromNow()}</span>
          </div>
          <div className={"video-stream-tv-item-info-desc"}>{video.desc}</div>
        </div>
        {video.user && (
          <div className={"video-stream-tv-item-info-user"}>
            <img src={video.user.image} />
          </div>
        )}
      </div>
    );
  };
}

export class VideoItemOffline extends Component {
  constructor(p) {
    super(p);
    this.state = {
      frameOffset: 4,
      video: null,
      isLoading: true,
      hasImage: true,
      msg: true,
      isWatching: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getData = () => {
    const { id } = this.props;
    const _that = this;
    const data = {
      user_id: FakeData.getData("yoo").id,
      id
    };

    FakeData.post(FakeData.apiURL+"/get-recorded-videos", data, {
      success(res) {
        if (res.status && res.hasVideo) {
          _that.setState({
            video: null,
            isLoading: false,
            msg: "Attachment no available"
          });
        } else if (res.status && !res.hasVideo) {
          _that.setState({ video: null, isLoading: false, msg: false });
        } else {
          _that.setState({ video: null, isLoading: false, msg: true });
        }
      },
      error(){
        _that.setState({ video: null, isLoading: false, msg: false });
      }
    });
  };

  render = () => {
    const { frame } = this.state;
    const { video, isLoading, msg, isWatching } = this.state;
    if (isLoading) {
      return <ShimmerView />;
    }

    if (!msg || video === null) {
      return null;
    }

    if (msg === "Attachment no available") {
      return null;
    }

    return (
      <div className={"video-stream-tv-item"}>
        
        {this.state.hasImage &&
          <img
          onError={()=>{
            this.setState({ hasImage: false });
          }}
          src={video.poster}
          onClick={() => {
            this.setState({
              isWatching: true
            });
          }}
        />
        }
        {!this.state.hasImage && video.user && video.user.image &&
          <img
          onError={()=>{
            this.setState({ hasImage: false });
          }}
          src={video.user.image}
          onClick={() => {
            this.setState({
              isWatching: true
            });
          }}
        />
        }
        <div
          className={"video-stream-tv-item-info"}
          onClick={() => {
            this.setState({
              isWatching: true
            });
          }}
        >
          <div className={"video-stream-tv-item-info-time"}>
            <span
              style={{
                background: "#e03"
              }}
            >
              Recorded Live
            </span>
            <span>{""}</span>
          </div>
          <div className={"video-stream-tv-item-info-desc"}>{video.desc}</div>
        </div>
        {video.user && (
          <div className={"video-stream-tv-item-info-user"}>
            <img src={video.user.image} />
          </div>
        )}
        {isWatching && (
          <VideoStreamTV
            onClose={() => {
              this.setState({ isWatching: false });
            }}
            user={{
              name: FakeData.getData("yoo").id,
              image: FakeData.getData("yoo").image,
              id: FakeData.getData("yoo").id,
              type: "F"
            }}
            vid_id={this.props.id}
            isLive={false}
            style={{
              zIndex: 9999,
              background: 'url(".././images/stadium_background.jpg")'
            }}
          />
        )}
      </div>
    );
  };
}

class GoLiveView extends Component {
  constructor(p) {
    super(p);
    this.state = {
      isLive: false,
      isSharing: false,
      isRecord: false,
      audience: [],
      whoToSee: false,
      isGame: this.props.isGame,
      video: null,
      desc: "",
      tag: { val: "Public" },
      streamKey: this.getNewKey(),
      user: this.props.user
        ? this.props.user
        : {
            id: FakeData.getData("yoo").id,
            name: FakeData.getData("yoo").name,
            image: FakeData.getData("yoo").image,
            type: "F",
            user: FakeData.getData("yoo").username
          },
      filter: "",
      isPickingCrowd: false,
      tags: [
        {
          key: "F",
          val: "Friends",
          img: ".././images/who_sees_friends.svg",
          bg: ""
        },
        {
          key: "Q",
          val: "Groups",
          img: ".././images/facebook-group.svg",
          bg: "#58CC66",
          withPadding: true
        },
        {
          key: "T",
          val: "Teams",
          img: ".././images/who_sees_game.svg",
          bg: ""
        },
        {
          key: "C",
          val: "Clubs",
          img: ".././images/club.svg",
          bg: "#f43",
          withPadding: true
        },
        {
          key: "L",
          val: "Tournaments",
          img: ".././images/who_sees_league.svg",
          bg: ""
        },
        {
          key: "I",
          val: "Institutions",
          img: ".././images/institution_icon.svg",
          bg: "#888",
          withPadding: true
        }
      ]
    };

    this.getRecorder = this.getRecorder.bind(this);
    this.videoHandler = this.videoHandler.bind(this);
    this.videoRestart = this.videoRestart.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.stream = null;
    this.conn = null;
    this.io = null;
    this.recoder = null;
    const _that = this;
    /*window.navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true
        }).then(function (stream) {
            //console.log(stream)
            _that.stream = stream;
            if (stream.stop && stream.getTracks) {
                _that.stream.stop = () => {
                    _that.stream.getTracks().forEach((item, i) => {
                        item.stop();
                    })
                };
            }
            _that.refs['video-holder'].srcObject = stream;
        }).catch(function (error) {

        });*/
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.stream && this.stream.stop && this.stream.getTracks) {
      this.stream.stop();
    }
  }

  getNewKey = () => {
    var user = this.props.isGame
      ? this.props.user.teamOne.squadId
      : btoa(FakeData.getData("yoo").username).split("=")[0];
    var mid = this.props.isGame
      ? new Date(this.props.user.fullDate).getTime()
      : btoa("_live_").split("=")[0];
    var end = this.props.isGame
      ? this.props.user.teamTwo.squadId
      : btoa(Date.now()).split("=")[0];
    var str = this.props.isGame
      ? user + "" + mid + "" + end
      : user + "_" + mid + "_" + end;
    var id = str;
    return id;
  };

  getRecorder = id => {
    console.log("reached");
    const _that = this;
    const opts = {
      mineType: "video/webm; codecs=vp8",
      audioBitsPerSecond: 128000
    };
    this.recoder = new MediaRecorder(this.stream, opts);
    this.recoder.ondataavailable = this.videoHandler;
    this.recoder.start(8000);
    this.recoder.onstop = this.videoRestart;
    this.recoder.onstart = start => {
      setTimeout(() => {
        if (_that.recoder && _that.state.isLive) {
          _that.recoder.stop();
        }
      }, 8000);
    };

    setTimeout(() => {
      _that.setState({
        isLive: false,
        user: { id: null },
        desc: "",
        video: null,
        streamKey: this.getNewKey()
      });
      if (_that.recoder) {
        _that.recoder.stop();
      }

      _that.recoder = null;

      if (_that.conn) {
        _that.conn.close();
      }
      _that.conn = null;

      if (_that.io) {
        _that.io.emit("end", "end");
      }

      _that.io = null;
    }, LIMIT_CUT_OFF + 8000);
  };

  videoHandler = event => {
    //console.log(event.data)
    const reader = new FileReader();
    const _that = this;
    reader.readAsArrayBuffer(event.data);
    reader.onloadend = e => {
      if (_that.conn && _that.state.isLive) {
        _that.conn.send(reader.result);
      }

      if (_that.io) {
        if (event.data.size !== 0) {
          _that.io.emit("stream", event.data);
        }
      }
    };
  };

  videoRestart = event => {
    if (this.recoder && this.state.isLive) {
      this.recoder.start(8000);
    }
  };

  setTime = (id, time = 1) => {
    const _that = this;
    const _nextTime = time + 1;
    const _d = {
      time: time
    };

    FakeData.post("http://supotsu.com:2018/set_time/" + id, _d, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }

        if (res.status && _that.conn && _that.state.isLive) {
          setTimeout(() => {
            _that.setTime(id, _nextTime);
          }, 1000);
        } else {
          _that.endStream();
        }
      },
      error(res) {}
    });
  };

  getVideoSocket = id => {
    const _that = this;
    var bool = false;

    const {
      isLive,
      video,
      desc,
      tag,
      tags,
      user,
      filter,
      isPickingCrowd
    } = this.state;
    if (desc.length < 10) {
      alert("Video description can't be less than 10 characters");
      bool = true;
      return;
    }

    if (desc.length > 150) {
      alert("Video description can't be more than 250 characters");
      bool = true;
      return;
    }

    var arr = ["Friends", "Public"];

    if (!FakeData.inArray(tag.val, arr) && user.id === null) {
      var _v = tag.val
        .split("")
        .pop()
        .join("");
      bool = true;
      alert("Please sure to select a/an " + _v);
      return;
    }

    const isRecord = window.confirm("Do you want to record this video?");

    if (!bool) {
      this.conn = new WebSocket("ws://supotsu.com:2018/ws/" + id);
      this.conn.binaryType = "blob";
      this.conn.onopen = e => {
        _that.getIOStream(id);
        _that.setState({ isRecord: isRecord });
      };

      this.conn.onmessage = e => {
        //console.log(e)
        if (_that.io) {
          //_that.io.emit("file_chunk", e.data);
        }
      };
    }
  };

  getIOStream = id => {
    const _that = this;
    this.io = new window.io.connect(FakeData.apiURL+"", {
      transports: ['polling', 'websocket']
    });
    this.io.once("io_connected", data => {
      //console.log(data);
      if (data.message === "Connected") {
        var url = "rtmp://supotsu.com/live/" + id;
        console.log("url:", url);
        if (_that.io) {
          _that.io.emit("set_stream_url", url);
          _that.io.emit("start", "start");
        }
      } else {
        console.log("Not connected");
      }
    });

    this.io.on("success_url", d => {
      console.log(d);
      _that.setState({ isLive: true, room_id: id });
      //_that.getRecorder(id);
      //_that.io.emit("stream-data", _that.stream)
    });

    this.io.on("fatal", data => {
      console.error("Socket error", data);
      _that.endStream(data === "ended" ? false : true);
    });

    this.io.on("go_live", bool => {
      if (bool) {
        //_that.setTime(id, 1);
        _that.props.setWatcher(id);
        _that.setVidData(id);
      } else {
        _that.endStream(false);
      }
    });

    this.io.on("request_end", bool => {
      if (_that.io) {
        _that.io.emit("end", "ende");
      }
    });

    this.io.on("request_live", bool => {
      if (_that.io) {
        setTimeout(() => {
          _that.io.emit("generate_poster", "");
        }, 3000);
      }
    });
  };

  postThis = video => {
    const _that = this;
    const newPost = {
      user: { type: "F", ...video.user },
      userTo: video.feature_user,
      type: 1,
      postType: "live",
      sport: {
        name: ""
      },
      is_live: "yes",
      vid_id: video._id,
      isEvent: false,
      content: video.desc,
      media: [],
      timeAgo: new Date(),
      isLiked: false,
      likes: [],
      place: "",
      shares: [],
      commentType: "post",
      audience: this.state.tag.val.toLowerCase(),
      tagged: this.state.audience,
      audienceList: this.state.audience,
      tagsLen: 0,
      comments: []
    };

    FakeData.post("/createPost.php?auth0", newPost, {
      success(res) {},
      error(err) {
        _that.endStream();
      }
    });
  };

  endStream = (_alert = true) => {
    const _that = this;
    _that.setState({
      isLive: false,
      user: { id: null },
      desc: "",
      video: null,
      streamKey: _that.getNewKey()
    });
    if (_that.recoder) {
      _that.recoder.stop();
    }

    _that.recoder = null;

    if (_that.conn) {
      _that.conn.close();
    }
    _that.conn = null;

    if (_that.io) {
      _that.io.emit("end", "end");
    }

    _that.io = null;

    _that.props.onReset();
    if (_alert) {
      //alert("Server encountered an error");
    }
  };

  cancelStream = cb => {
    if (this.io) {
      this.io.emit("end", "end");
    }

    setTimeout(() => {
      if (cb) {
        cb();
      }
    }, 1500);
  };

  setVidData = vid_id => {
    const {
      isLive,
      video,
      desc,
      isRecord,
      tag,
      tags,
      user,
      filter,
      isPickingCrowd,
      audience
    } = this.state;
    var canvas = this.refs["canvasFrame"];
    var videoElem = this.refs["video-holder"];
    var height = videoElem.height;
    var width = videoElem.width;
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(videoElem, 0, 0, width, height);
    var _d = canvas.toDataURL("image/png");
    const friends = audience.filter((f, i) => {
      return f.type === "F";
    });

    const user_friends = FakeData.getData("yoo").friends;
    const user_friend_ids = [];

    friends.forEach((f, i) => {
      user_friend_ids.push(f.id);
    });

    let blocked = [];

    if (friends.length === 0) {
      blocked = [];
    } else {
      user_friends.forEach((f, i) => {
        if (!FakeData.inArray(f.id, user_friend_ids)) {
          blocked.push(f.id);
        }
      });
    }

    const data = {
      user: {
        id: FakeData.getData("yoo").id,
        name: FakeData.getData("yoo").name,
        username: FakeData.getData("yoo").username,
        image: FakeData.getData("yoo").image,
        type: "F"
      },
      desc,
      tagList: tag.val,
      feature_user: user,
      image: _d,
      isRecord: isRecord
    };

    const apiData = {
      user: {
        id: FakeData.getData("yoo").id,
        name: FakeData.getData("yoo").name,
        user: FakeData.getData("yoo").username,
        image: FakeData.getData("yoo").image
      },
      desc,
      name: vid_id,
      block: blocked,
      tags: [tag.val],
      feature_user: user,
      is_recorded: true,
      is_saved: false,
      src: FakeData.apiURL+"/" + vid_id + ".flv",
      hls: "http://supotsu.com:2017/live/" + vid_id + "/index.m3u8",
      poster: FakeData.apiURL+"/streams/" + vid_id + ".png"
    };

    //console.log(apiData);

    const _that = this;
    let videoData = null;

    FakeData.post(FakeData.apiURL+"/go-live", apiData, {
      success(res) {
        if (!_that._isMounted) {
          return;
        }

        //document.removeChild(canvas)
        data._id = res._id;
        videoData = res;
        FakeData.post(
          "http://supotsu.com:2018/update_video_meta/" + vid_id,
          data,
          {
            success(res) {
              //console.log(res);
              if (_that.state.isRecord) {
                _that.postThis(videoData);
              }

              if (res._id && _that.conn && _that.state.isLive) {
                setTimeout(() => {
                  _that.getVideData(vid_id);
                }, 1000);
              } else {
                _that.endStream();
              }
            },
            error(err) {
              _that.endStream();
            }
          }
        );
      },
      error(res) {
        _that.endStream();
      }
    });

    /*FakeData.post("http://supotsu.com:2018/update_video_meta/" + vid_id, data, {
            success(res) {
                if (!_that._isMounted) {
                    return;
                }

                //document.removeChild(canvas)
                FakeData.post(FakeData.apiURL+"/go-live", apiData, {
                    success(res){
                        //console.log(res);
                        if(_that.state.isRecord){
                            _that.postThis(res)
                        }
                    }, 
                    error(err){
                        _that.endStream()
                    }
                });
            },
            error(res) {

            }
        })*/
  };

  getVideData = id => {
    const _that = this;

    FakeData.post(
      "http://supotsu.com:2018/get/" + id,
      {},
      {
        success(res) {
          if (!_that._isMounted) {
            return;
          }

          if (!res.status) {
            _that.setState({ video: res });
            _that.props.setComments(res.msgs);
          }

          setTimeout(() => {
            _that.getVideData(id);
          }, 1500);
        },
        error(res) {}
      }
    );
  };

  render() {
    const {
      isLive,
      video,
      desc,
      tag,
      tags,
      user,
      filter,
      isPickingCrowd,
      isSharing,
      streamKey,
      isGame
    } = this.state;
    const { isHiding, isStreaming, canClose } = this.props;
    return (
      <div
        className={
          isHiding
            ? "video-stream-tv-video is-expanded"
            : "video-stream-tv-video"
        }
      >
        <div className={"video-stream-tv-video-head is-expanded"}>
          {!isStreaming && (
            <button
              className={"live-tv"}
              onClick={() => {
                this.setState({ isHiding: true, isStreaming: true });
              }}
            >
              GO LIVE
            </button>
          )}
          {isStreaming && (
            <button
              className={"live-tv"}
              onClick={() => {
                this.cancelStream(
                  this.props.hasCancel
                    ? this.props.onCloseStream
                    : this.props.onClose
                );
              }}
            >
              Cancel
            </button>
          )}
          <img src={FakeData.getData("yoo").image} />
          {canClose && (
            <button
              className={"close-me"}
              onClick={() => {
                this.cancelStream(this.props.onClose);
              }}
            >
              CLOSE
            </button>
          )}
        </div>
        <div
          className={
            isHiding
              ? "video-stream-tv-video-body is-expanded"
              : "video-stream-tv-video-body"
          }
        >
          <video
            ref={"video-holder"}
            muted={true}
            className="local-video"
            autoPlay={true}
            src={""}
            onPlay={e => {}}
            onPause={e => {}}
            onProgress={e => {}}
          />
          <canvas ref={"canvasFrame"} style={{ display: "none" }} />
          <div className={"video-holder-data"}>
            <h2 style={{ marginTop: "0px" }}>Stream RTMP Info</h2>
            <code
              style={{
                display: "block",
                padding: "10px",
                marginBottom: "15px"
              }}
            >
              NB : We currently do not support streaming videos via the web
              browser!
            </code>
            <InputField label={"RTMP URL"}>
              <input
                value={
                  isGame ? "rtmp://supotsu.com/game" : "rtmp://supotsu.com/live"
                }
                readOnly
              />
            </InputField>
            <InputField label={"RTMP Secret Key"}>
              <input value={streamKey} readOnly />
            </InputField>
            <code
              style={{
                display: "block",
                padding: "10px",
                marginBottom: "15px"
              }}
            >
              TO-DO : Copy the stream details above, use them on any live
              broadcasting encoder software. Then fill in the required fields
              for Supotsu Live Videos, when done, you can start your stream by
              clicking on the "Start live video" button. Note that your stream
              won't be live until we receive data from you chosen streaming
              software and any errors your encounter on that software might end
              your live video!
            </code>
          </div>
        </div>
        <div
          className={
            isHiding
              ? "video-stream-tv-video-chat"
              : "video-stream-tv-video-chat is-expanded"
          }
        />
        <div className={"video-stream-tv-video-foot"}>
          <div className={"video-stream-tv-video-foot-desc"}>
            <div className={"video-stream-tv-video-foot-desc-lbl"}>
              {!isLive && (
                <span
                  className={"lbl"}
                  onClick={() => {
                    this.getVideoSocket(streamKey);
                  }}
                >
                  START LIVE VIDEO
                </span>
              )}
              {isLive && (
                <span
                  className={"lbl"}
                  onClick={() => {
                    this.setState({
                      isLive: false,
                      user: { id: null },
                      desc: "",
                      video: null,
                      streamKey: this.getNewKey()
                    });
                    if (this.recoder) {
                      this.recoder.stop();
                    }

                    this.recoder = null;

                    if (this.conn) {
                      this.conn.close();
                    }

                    this.conn = null;

                    if (this.io) {
                      this.io.emit("end", "end");
                    }

                    this.io = null;
                  }}
                >
                  END LIVE VIDEO
                </span>
              )}
              <i className="material-icons">person</i>
              <span className={"v-count"}>
                {FakeData.shortDigit(video === null ? 0 : video.views).text}
              </span>
            </div>
            <div className={"video-stream-tv-video-foot-desc-ctx"}>
              {isLive && video !== null ? video.desc : ""}
              {(video === null || desc === "") &&
                !isLive && (
                  <textarea
                    placeholder={"Say something..."}
                    value={desc}
                    onChange={e => {
                      this.setState({ desc: e.target.value });
                    }}
                  />
                )}
            </div>
            {this.is && <i className="material-icons">favorite_border</i>}
          </div>
          {!isGame && (
            <div className={"video-stream-tv-video-foot-actions"}>
              <div className={"video-stream-tv-video-foot-user"}>
                <img src={FakeData.getData("yoo").image} />
                <span>{FakeData.getData("yoo").name}</span>
              </div>
              <div style={{ flex: 1 }} />
              {!isLive && (
                <div className={"video-stream-tv-video-foot-side-actions"}>
                  <span
                    onClick={() => {
                      this.setState({
                        whoToSee: true
                      });
                    }}
                  >
                    Who should see this?
                  </span>
                </div>
              )}
              {!isLive && <div style={{ width: 15 }} />}
              <div className={"video-stream-tv-video-foot-side-crowd-picker"}>
                <div
                  className="video-stream-tv-video-foot-side-crowd-picker-btn"
                  onClick={() => {
                    this.setState({
                      isPickingCrowd: !isPickingCrowd,
                      filter: ""
                    });
                  }}
                >
                  {!tag.img && <i className="material-icons">public</i>}
                  {tag.img && (
                    <img
                      src={tag.img}
                      style={{
                        background: tag.withPadding ? tag.bg : "",
                        padding: tag.withPadding ? "2px" : ""
                      }}
                    />
                  )}
                  <span>{tag.val}</span>
                </div>
                {isPickingCrowd &&
                  !isLive && (
                    <div
                      className={
                        "video-stream-tv-video-foot-side-crowd-picker-list"
                      }
                    >
                      <div
                        className={
                          "video-stream-tv-video-foot-side-crowd-picker-item"
                        }
                        onClick={() => {
                          this.setState({
                            isPickingCrowd: false,
                            filter: "",
                            user: {
                              id: FakeData.getData("yoo").id,
                              name: FakeData.getData("yoo").name,
                              image: FakeData.getData("yoo").image,
                              type: "F",
                              user: FakeData.getData("yoo").username
                            },
                            tag: { val: "Public" }
                          });
                        }}
                      >
                        <i className="material-icons">public</i>
                        <span>{"Public"}</span>
                      </div>
                      {tags.map((item, i) => {
                        if (item.val === "Friends") {
                          return null;
                        }
                        return (
                          <div
                            className={
                              "video-stream-tv-video-foot-side-crowd-picker-item"
                            }
                            key={i}
                            onClick={() => {
                              this.setState({
                                isPickingCrowd: false,
                                filter: "",
                                user: { id: null },
                                tag: item
                              });
                            }}
                          >
                            <img
                              src={item.img}
                              style={{
                                background: item.withPadding ? item.bg : "",
                                padding: item.withPadding ? "2px" : ""
                              }}
                            />
                            <span>{item.val}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                {!isLive && (
                  <div
                    className={
                      "video-stream-tv-video-foot-side-crowd-picker-ctx"
                    }
                  >
                    {filter !== "" &&
                      !isPickingCrowd && (
                        <div
                          className={
                            "video-stream-tv-video-foot-side-crowd-picker-ctx-list"
                          }
                        >
                          {tag.val === "Clubs" &&
                            FakeData.getData("yoo")
                              .clubs.filter((item, i) => {
                                var index = FakeData.nullify(item.name)
                                  .toLowerCase()
                                  .indexOf(filter.toLowerCase());
                                return index > -1;
                              })
                              .map((item, i) => {
                                return (
                                  <div
                                    className={
                                      "video-stream-tv-video-foot-side-crowd-picker-ctx-item"
                                    }
                                    key={i}
                                    onClick={() => {
                                      this.setState({
                                        filter: "",
                                        user: {
                                          id: item.id,
                                          user: item.user,
                                          name: item.name,
                                          image: item.image,
                                          type: "C"
                                        }
                                      });
                                    }}
                                  >
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                  </div>
                                );
                              })}
                          {tag.val === "Teams" &&
                            FakeData.getData("yoo")
                              .pages.filter((item, i) => {
                                return (
                                  item.type === "T" &&
                                  FakeData.nullify(item.name)
                                    .toLowerCase()
                                    .indexOf(filter.toLowerCase()) > -1
                                );
                              })
                              .map((item, i) => {
                                return (
                                  <div
                                    className={
                                      "video-stream-tv-video-foot-side-crowd-picker-ctx-item"
                                    }
                                    key={i}
                                    onClick={() => {
                                      this.setState({
                                        filter: "",
                                        user: {
                                          id: item.id,
                                          user: item.user,
                                          name: item.name,
                                          image: item.image
                                        }
                                      });
                                    }}
                                  >
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                  </div>
                                );
                              })}
                          {tag.val === "Institutions" &&
                            FakeData.getData("yoo")
                              .institutions.filter((item, i) => {
                                return (
                                  FakeData.nullify(item.name)
                                    .toLowerCase()
                                    .indexOf(filter.toLowerCase()) > -1
                                );
                              })
                              .map((item, i) => {
                                return (
                                  <div
                                    className={
                                      "video-stream-tv-video-foot-side-crowd-picker-ctx-item"
                                    }
                                    key={i}
                                    onClick={() => {
                                      this.setState({
                                        filter: "",
                                        user: {
                                          id: item.id,
                                          user: item.user,
                                          name: item.name,
                                          image: item.image,
                                          type: "I"
                                        }
                                      });
                                    }}
                                  >
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                  </div>
                                );
                              })}
                          {tag.val === "Tournaments" &&
                            FakeData.getData("yoo")
                              .leagues.filter((item, i) => {
                                return (
                                  FakeData.nullify(item.name)
                                    .toLowerCase()
                                    .indexOf(filter.toLowerCase()) > -1
                                );
                              })
                              .map((item, i) => {
                                return (
                                  <div
                                    className={
                                      "video-stream-tv-video-foot-side-crowd-picker-ctx-item"
                                    }
                                    key={i}
                                    onClick={() => {
                                      this.setState({
                                        filter: "",
                                        user: {
                                          id: item.id,
                                          user: item.hash,
                                          name: item.name,
                                          image: item.image,
                                          type: "L"
                                        }
                                      });
                                    }}
                                  >
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                  </div>
                                );
                              })}
                          {tag.val === "Groups" &&
                            FakeData.getData("yoo")
                              .groups.filter((item, i) => {
                                return (
                                  FakeData.nullify(item.name)
                                    .toLowerCase()
                                    .indexOf(filter.toLowerCase()) > -1
                                );
                              })
                              .map((item, i) => {
                                return (
                                  <div
                                    className={
                                      "video-stream-tv-video-foot-side-crowd-picker-ctx-item"
                                    }
                                    key={i}
                                    onClick={() => {
                                      this.setState({
                                        filter: "",
                                        user: {
                                          id: item.id,
                                          user: item.user,
                                          name: item.name,
                                          image: item.image,
                                          type: "Q"
                                        }
                                      });
                                    }}
                                  >
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                  </div>
                                );
                              })}
                        </div>
                      )}
                    {user.id === null && (
                      <div
                        className={
                          "video-stream-tv-video-foot-side-crowd-picker-ctx-search"
                        }
                      >
                        <i className="material-icons">search</i>
                        <input
                          placeholder={"Broadcast as ...."}
                          value={filter}
                          onChange={e => {
                            this.setState({
                              filter: e.target.value,
                              isPickingCrowd: false
                            });
                          }}
                        />
                      </div>
                    )}
                    {user.id !== null && (
                      <div
                        className={
                          "video-stream-tv-video-foot-side-crowd-picker-ctx-user"
                        }
                      >
                        <img src={user.image} />
                        <span>{user.name}</span>
                        {this.is&&<i
                          className="material-icons"
                          onClick={() => {
                            this.setState({
                              user: { id: null }
                            });
                          }}
                        >
                          close
                        </i>}
                      </div>
                    )}
                  </div>
                )}
              </div>

              {isLive && <div style={{ flex: 1 }} />}
              {isLive && (
                <div className={"video-stream-tv-video-foot-side-actions"}>
                  <span
                    onClick={() => {
                      this.setState({
                        isSharing: true
                      });
                    }}
                  >
                    Share
                  </span>
                  {this.is && (
                    <i
                      className="material-icons"
                      onClick={() => {
                        document
                          .querySelector(".video-stream-tv-video-body")
                          .querySelector("video")
                          .requestFullscreen();
                      }}
                    >
                      aspect_ratio
                    </i>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        {isSharing &&
          video !== null && (
            <ShareContent
              hideSportLabel={true}
              style={null}
              post={video}
              isVideo={true}
              type={"VIDEO"}
              user={FakeData.getData("yoo")}
              userType={"F"}
              isOpen={isSharing}
              onClose={() => {
                this.setState({ isSharing: false });
              }}
            >
              <VideoItem
                onVideoSelect={() => {}}
                isLive={video.is_live}
                video={video}
              />
            </ShareContent>
          )}
        {this.state.whoToSee && (
          <WhoToSeePicker
            isVideo={true}
            active={"F"}
            isOpen={this.state.whoToSee}
            onClose={arr => {
              this.setState({ audience: arr, whoToSee: false });
            }}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoStreamTV.js